<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>场馆监管系统</el-breadcrumb-item>
        <el-breadcrumb-item>游泳馆</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>待审核人员</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="120px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="登记手机号码：">
              <el-input
                size="small"
                v-model="listParams.vipMobile"
                placeholder="请输入登记手机号码"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="审核状态：">
              <el-select
                clearable
                style="width: 100%;"
                size="small"
                v-model="listParams.businessStatus"
                placeholder="请选择审核状态"
              >
                <el-option
                  v-for="item in identificationStatusList"
                  :label="item.title"
                  :value="item.id"
                  :key="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData">
                查询
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px;">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="name" align="center" label="用户姓名">
        </el-table-column>

        <el-table-column prop="mobile" align="center" label="手机号码">
        </el-table-column>

        <el-table-column prop="vipMobile" align="center" label="登记手机号">
        </el-table-column>

        <el-table-column prop="businessStatus" align="center" label="审核状态">
          <template slot-scope="scope">
            <span v-if="scope.row.businessStatus === 0">未审核</span>
            <span v-if="scope.row.businessStatus === 1">通过</span>
            <span v-if="scope.row.businessStatus === 2">未通过</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <confirm-button
              type="text"
              title="确认要删除该条数据 ？"
              @confirmed="deleteItem(scope.row.id)"
            >
              <span>删除</span>
            </confirm-button>
            <el-button
              v-if="scope.row.businessStatus === 0"
              type="text"
              @click="openAuditDialog(scope.row.id)"
            >
              审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog
      class="hx-to-create-template"
      title="审核认证"
      :visible.sync="dialogVisible"
      width="40%"
      @close="resetDialogForm"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          ref="dialogForm"
          :model="itemParams"
          :rules="checkItemParams"
          label-width="120px"
        >
          <el-form-item label="审核认证 ：" prop="businessStatus">
            <el-select
              style="width: 100%;"
              size="small"
              v-model="itemParams.businessStatus"
              placeholder="请选择审核认证"
            >
              <el-option label="通过" :value="1"></el-option>
              <el-option label="拒绝" :value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              size="small"
              type="primary"
              @click="auditItem('dialogForm')"
            >
              审 核
            </el-button>

            <el-button size="small" @click="dialogVisible = false">
              取 消
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        vipMobile: "",
        businessStatus: "",
        stadiumType: ""
      },
      identificationStatusList: [
        { id: "", title: "全部" },
        { id: "0", title: "未审核" },
        { id: "1", title: "通过" },
        { id: "2", title: "未通过" }
      ],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      dialogVisible: false,
      supplyCentreList: [],
      itemParams: {
        id: "",
        businessStatus: 1
      },
      checkItemParams: {
        businessStatus: [
          { required: true, message: "请选择审核状态", trigger: "change" }
        ]
      }
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = this.commonBodyParams(this.listParams, this.pager);
      bodyParams.stadiumType = parseInt(this.$route.params.stadiumType);
      this.$http({
        url: global.apiUrl + "/stadium/user/examine/list",
        method: "GET",
        params: bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.tableData = res.body.data.dataList;
            this.pager.total = res.body.data.total;
          } else {
            this.tableLoading = false;

          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/stadiumManage/user/examine/delete",
        method: "DELETE",
        params: {
          stadiumType: parseInt(this.$route.params.stadiumType),
          id: id
        }
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {

          }
        })
        .catch(err => {

          console.error(err);
        });
    },
    /**
     * 打开审核对话框
     * @param id
     */
    openAuditDialog(id) {
      this.dialogVisible = true;
      this.itemParams.id = id;
    },
    /**
     * 审核条目数据
     * @param name
     */
    auditItem(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          const bodyParams = Object.assign({}, this.itemParams, {
            stadiumType: parseInt(this.$route.params.stadiumType)
          });
          this.$http({
            url: global.apiUrl + "/stadiumManage/user/examine",
            method: "POST",
            body: bodyParams
          }).then(res => {
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              this.dialogVisible = false;
              this.isDisabled = false;
              this.$message.success(res.body.info);
              this.loadTableData();
            } else {

              this.isDisabled = false;
            }
          });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
